import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';
import { combineReducers } from 'redux';
import { BasicNotification } from '../../model';

type ClientNotification = {
  text: string,
  closable?: boolean,
  timer?: boolean,
}
type ClientNotifications = Record<string, ClientNotification>

let lastId = 0;

export function clientNotification(state: ClientNotifications = {}, action: Actions): ClientNotifications {
  if (action.type === getType(actions.showClientNotification)) {
    return {
      ...state,
      [(lastId++).toString()]: { text: action.payload.text, closable: action.payload.closable, timer : action.payload.timer },
    }
  } else if (action.type === getType(actions.closeClientNotification)) {
    const s = state[action.payload]
    if (s && s.closable === false) return state
    const { [action.payload]: _, ...rest } = state
    return rest
  } else if (action.type === getType(actions.shutdown)) {
    return {}
  }

  return state
}

type ServerNotification = Record<string, BasicNotification>
export function serverNotification(state: ServerNotification = {}, action: Actions): ServerNotification {
  if (action.type === getType(actions.showServerNotification)) {
    return {
      ...state,
      [(lastId++).toString()]: action.payload,
    }
  } else if (action.type === getType(actions.closeServertNotification)) {
    const { [action.payload]: _, ...rest } = state
    return rest
  } else if (action.type === getType(actions.shutdown)) {
    return {}
  }

  return state
}

export default combineReducers({
  clientNotification,
  serverNotification,
})

function getRoot(state: StoreState) { return state.toasts }
function getClientNotifications(state: StoreState) { return getRoot(state).clientNotification }
function getServerNotifications(state: StoreState) { return getRoot(state).serverNotification }

export function selectClientNotifcations(state: StoreState): ClientNotifications {
  return getClientNotifications(state)
}

export function selectServerNotifcations(state: StoreState): ServerNotification {
  return getServerNotifications(state)
}
